import React from 'react'
import { Route, Switch, RouteComponentProps } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import UserSearch from './search/UserSearch'
import User from './User'

interface UserManagerProps extends RouteComponentProps {}

class UserManager extends React.Component<UserManagerProps> {
  render = () => {
    const { match } = this.props

    return (
      <ErrorBoundary>
        <Switch>
          <Route component={User} path={`${match.path}/:email/:id`} />
          <Route component={UserSearch} path={match.path} />
        </Switch>
      </ErrorBoundary>
    )
  }
}

export default UserManager
